<template>
  <div class="container has-text-centered">

    <div class="columns">
      <div class="column is-4 is-hidden-mobile"></div>
      <div class="column is-4">
        <div class="image has-padding-b-3 has-padding-lr-3-on-mobile">
        <figure class="is-relative">
          <img src="../../assets/img/logoText.png">
        </figure>
          </div>
      </div>
      <div class="column is-4 is-hidden-mobile"></div>
    </div>

    <h1 class="title has-text-white is-relative is-pre-formatted-mobile is-size-2-mobile">{{title}}</h1>
    <h2 class="subtitle has-text-white has-margin-b-5 is-pre-formatted-mobile is-size-4-mobile is-relative">{{subtitle}}</h2>
    <h3 class="subtitle has-text-white has-margin-b-7 has-padding-t-3 is-relative">{{subtitle2}}</h3>

    <div class="columns">
      <div class="column is-hidden-mobile"></div>
      <div class="column is-two-fifths" >
        <landing-form></landing-form>
      </div>
      <div class="column is-hidden-mobile"></div>
    </div>

  </div>
</template>

<script>
import LandingForm from './LandingForm'

export default {
  name: 'LandingBody',
  data: function () {
    return {
      title: 'Think feeling \n your best needs \n to be difficult?',
      subtitle: 'Our AI technology makes it \n as easy as riding a bike!',
      subtitle2: 'Sign up to discover how.',
      title_thanks: 'Great...you are in!',
      subtitle_thanks: 'Invite your friends and move up the waitlist!',
      subtitle_thanks2: '',
      currentComponent: LandingForm
    }
  },
  components: {
    LandingForm
  }
}
</script>

<style scoped>
  .is-relative {
    position: relative;
    z-index: 2;
  }

  @media only screen and (max-width: 768px) {
    .has-padding-lr-3-on-mobile {
      padding-left: 5rem;
      padding-right: 5rem;
      /*padding-bottom: 0 !important;*/
    }
    .is-pre-formatted-mobile {
        font-family: Nunito, Georgia, serif;
        white-space: pre;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/landingPage/LandingBody.vue